/**
 * Reserved profile.privateData keys for Reef2Reef managed auth / SSO.
 * Client profile updates must not overwrite or null these out.
 * Keep in sync with config/r2rManagedAuthPrivateData.js (server).
 */

export const R2R_MANAGED_AUTH_PRIVATE_DATA_KEYS = [
  'r2rManagedAuth',
  'r2rManagedAuthEnc',
  'xfUserId',
  'xfUserGroupIds',
];

/**
 * Strip reserved managed-auth / SSO keys from a privateData patch.
 * Sharetribe merges top-level keys; omitting them preserves server-managed values.
 *
 * @param {object|null|undefined} privateData
 * @returns {object|null|undefined}
 */
export function omitReservedManagedAuthPrivateData(privateData) {
  if (!privateData || typeof privateData !== 'object') {
    return privateData;
  }
  const next = { ...privateData };
  for (const key of R2R_MANAGED_AUTH_PRIVATE_DATA_KEYS) {
    delete next[key];
  }
  return next;
}
